import { Helmet } from "react-helmet-async";

/**
 * Injects a <script type="application/ld+json"> into <head>.
 * Consumers pass a plain JS object; we stringify safely.
 * Docs: https://developers.google.com/search/docs/appearance/structured-data
 */
export function StructuredData({ data }) {
  if (!data) return null;
  // Escape </script to prevent breaking the closing tag
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return (
    <Helmet>
      <script type="application/ld+json">{json}</script>
    </Helmet>
  );
}

// ---------- Ready-made schema builders ----------

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "depoia",
  url: "https://depoia.com.br",
  logo: "https://depoia.com.br/favicon-192.png",
  sameAs: [
    "https://www.instagram.com/depoiaoficial",
    "https://x.com/depoiaoficial",
    "https://www.linkedin.com/company/depoia",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    email: "contato@depoia.com.br",
    contactType: "customer support",
    areaServed: ["BR", "US"],
    availableLanguage: ["Portuguese", "English"],
  },
};

export function softwareAppSchema(locale = "pt") {
  const isPt = locale === "pt";
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "depoia",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Any (Web)",
    description: isPt
      ? "Colete depoimentos em vídeo, voz e texto dos seus clientes pelo celular e exiba num mural no seu site."
      : "Collect video, voice and text testimonials from your customers via mobile and display them on a wall on your site.",
    url: `https://depoia.com.br/${locale}`,
    inLanguage: isPt ? "pt-BR" : "en",
    offers: [
      {
        "@type": "Offer",
        name: isPt ? "Grátis" : "Free",
        price: "0",
        priceCurrency: isPt ? "BRL" : "USD",
        availability: "https://schema.org/InStock",
      },
      {
        "@type": "Offer",
        name: "Pro",
        price: isPt ? "49.00" : "15.00",
        priceCurrency: isPt ? "BRL" : "USD",
        availability: "https://schema.org/InStock",
      },
    ],
    publisher: {
      "@type": "Organization",
      name: "depoia",
      url: "https://depoia.com.br",
    },
  };
}

export function faqSchema(items = []) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: it.a,
      },
    })),
  };
}

export function breadcrumbSchema(items = []) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: it.name,
      item: it.url,
    })),
  };
}
